import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from '../../../mixin/mixin.js'
export default {
  mixins: [mixx],
  name: "resumenLoteEquipo",
  data() {
    return {
      loading: false,
      loading_f: false,
      tbv: null,
      ventas: [],
      f_c: {
        desde: this.date_rest(this.currentdate(), -15) + "T00:00",
        hasta: this.currentdate() + "T23:59",
        estado: false
      }
    };
  },

  mounted: function () {
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      "autoWidth": false,
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      "columnDefs": [
        { className: "dt-right", "targets": [4, 5, 6, 7, 8, 9, 10] },
      ]

    });
    $('.box').boxWidget();
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
  },


  computed: {
    reporte: function () {
      return (
        "/loteip/resumen/lote-equipo?" +
        "&desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta +
        "&estado=" +
        this.f_c.estado
      );
    }
  },
  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post('/loteip/resumen/lote-equipo', this.f_c)
        .then(response => {
          if (response.data.status == 1) {
            response.data.data.forEach(fila => {
              for (let index = 7; index < fila.length; index++) {
                fila[index] = this.num_to_many(parseFloat(fila[index]).toFixed(2));
              }
              this.tbv.row.add(fila);
            });
          }
          this.tbv.draw();
          this.loading = false;
        });

    },

  },

  components: {
    barra,
    barrais,
    foot,
    barrade
  }
}



// WEBPACK FOOTER //
// ./src/components/posintegrado/resumenLoteEquipo/index.js